export const colunas = [
  {
    title: '#',
    dataIndex: 'ClienteId',
    key: 'ClienteId',
    width: 76
  },
  {
    title: 'Nome',
    dataIndex: 'Nome',
    key: 'Nome'
  },
  {
    title: 'Telefone Comercial',
    dataIndex: 'TelefoneComercial',
    key: 'Telefone'
  },
  {
    title: 'Email Principal',
    dataIndex: 'EmailPrincipal',
    key: 'Email'
  }
]